import { Injector } from '@angular/core';
export const AppConstants = {
  injector: <Injector>{},
  defaultCountry: 'PK',
  defaultTimeZone: '250',
  defaultCurrency: 'PKR',
  app_name: 'SA Web',
  app_id: '6FAE464C-1980-4A67-AAAE-98D9DDB04CE1',
  header_name: "X-APP-ID",
};
